import { MANIFEST_URL } from '../constants'
import { ProjectManifest } from '../types/ProjectManifest'

export async function fetchManifest(): Promise<ProjectManifest> {
  return fetch(MANIFEST_URL).then((res) => res.json())
}
